import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_update_shipment",
  ref: "updateShipmentRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_update_shipment_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1)
const _hoisted_9 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-7" }
const _hoisted_15 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-7" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_19 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_20 = { class: "form-group mb-7" }
const _hoisted_21 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_22 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_23 = { class: "form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, null, -1)
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = { class: "table align-middle table-row-dashed gy-5 mb-0" }
const _hoisted_29 = { class: "text-start text-gray-400 fw-bold text-uppercase gs-0" }
const _hoisted_30 = {
  colspan: "5",
  class: "text-start"
}
const _hoisted_31 = {
  colspan: "4",
  class: "text-start"
}
const _hoisted_32 = { class: "text-end w-50px" }
const _hoisted_33 = { class: "fw-bold text-gray-800" }
const _hoisted_34 = {
  colspan: "5",
  class: "text-start"
}
const _hoisted_35 = { class: "w-100" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = { class: "symbol symbol-50px overflow-hidden me-sm-2" }
const _hoisted_38 = { class: "symbol-label bg-transparent" }
const _hoisted_39 = { class: "flex-fill" }
const _hoisted_40 = { class: "mb-1" }
const _hoisted_41 = { class: "mw-300px text-line-clamp-1 break-all" }
const _hoisted_42 = {
  colspan: "4",
  class: "text-start"
}
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "text-end min-w-100px" }
const _hoisted_46 = { class: "modal-footer align-items-center justify-content-end max-sm-justify-content-center" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "indicator-label" }
const _hoisted_49 = { class: "svg-icon svg-icon-2" }
const _hoisted_50 = { class: "indicator-progress" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "indicator-label" }
const _hoisted_54 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_55 = { class: "indicator-progress" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_common_logistics_service_provider_option = _resolveComponent("common-logistics-service-provider-option")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_5, [
                  (_ctx.props.id === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.t("orderRequest.createShipment")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.t("orderRequest.editShipment")), 1))
                ]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("orderRequest.shippingDate")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipping_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "w-100",
                          modelValue: _ctx.formData.shipping_date,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.shipping_date) = $event)),
                          type: "date",
                          placeholder: _ctx.t('common.pickDate'),
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (
                        _ctx.commonChangeDefaultDate(
                          $event,
                          _ctx.formData,
                          'shipping_date'
                        )
                      )),
                          teleported: false
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("orderRequest.carrier")), 1),
                    _createVNode(_component_el_form_item, { prop: "carrier" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.carrier,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.carrier) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          onChange: _ctx.carrierChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.carrier, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_common_logistics_service_provider_option, { LogisticsServiceProviderOption: item }, null, 8, ["LogisticsServiceProviderOption"])
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "onChange"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.formData.carrier !== -1 && _ctx.formData.carrier !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("shipments.trackingNo")), 1),
                        _createVNode(_component_el_form_item, { prop: "tracking_no" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.tracking_no,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.tracking_no) = $event)),
                              modelModifiers: { trim: true },
                              type: "text",
                              placeholder: _ctx.t('common.plsEnter'),
                              disabled: _ctx.formData.status >= _ctx.ShipmentStatus.Delivered,
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder", "disabled"])
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_form_item, { prop: "tracking_nos" }, null, 512), [
                          [_vShow, 0]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.formData.carrier === -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("orderRequest.pickUpBy")), 1),
                        _createVNode(_component_el_form_item, { prop: "pick_up_by" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.pick_up_by,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.pick_up_by) = $event)),
                              type: "text",
                              placeholder: _ctx.t('common.plsEnter'),
                              clearable: ""
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.shippedItems")), 1),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "shipment_items" }, null, 512), [
                [_vShow, 0]
              ]),
              _withDirectives(_createVNode(_component_el_form_item, { prop: "status" }, null, 512), [
                [_vShow, 0]
              ]),
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("table", _hoisted_28, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_29, [
                        _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.t("order.product")), 1),
                        _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.t("order.sku")), 1),
                        _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.t("order.qty")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.shipment_items, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("span", _hoisted_38, [
                                    (item.__show.product_gallery)
                                      ? (_openBlock(), _createBlock(_component_el_image, {
                                          key: 0,
                                          class: "w-100 h-100 cursor-pointer",
                                          src: 
                                    item.__show.product_gallery +
                                    '?x-oss-process=image/resize,l_200'
                                  ,
                                          fit: "contain"
                                        }, null, 8, ["src"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("div", _hoisted_40, _toDisplayString(item.brand_name), 1),
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(item.__show.product_name), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_42, [
                            (_ctx.props.id === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", null, _toDisplayString(item.article_no), 1),
                                  _createElementVNode("div", {
                                    innerHTML: 
                              _ctx.t('order.colorAndSize', [item.color, item.size])
                            
                                  }, null, 8, _hoisted_43)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("div", null, _toDisplayString(item.__show.article_no), 1),
                                  _createElementVNode("div", {
                                    innerHTML: 
                              _ctx.t('order.colorAndSize', [
                                item.__show.color,
                                item.__show.size,
                              ])
                            
                                  }, null, 8, _hoisted_44)
                                ], 64))
                          ]),
                          _createElementVNode("td", _hoisted_45, [
                            (_ctx.props.id === 0)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  class: "w-100",
                                  modelValue: item.shipped_qty,
                                  "onUpdate:modelValue": ($event: any) => ((item.shipped_qty) = $event)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: '',
                                      value: ''
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.max_qty, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: rowIndex,
                                        label: row,
                                        value: row
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(item.shipping_qty), 1)
                                ], 64))
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_46, [
              _withDirectives(_createElementVNode("button", {
                type: "submit",
                ref: _ctx.submitButton,
                disabled: _ctx.loading,
                class: "btn btn-lg btn-primary"
              }, [
                _createElementVNode("span", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, [
                    _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.save")), 1)
                ]),
                _createElementVNode("span", _hoisted_50, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_51
                ])
              ], 8, _hoisted_47), [
                [_vShow, _ctx.props.id !== 0]
              ]),
              _withDirectives(_createElementVNode("button", {
                type: "submit",
                ref: _ctx.submitButton,
                disabled: _ctx.loading || _ctx.getShipmentItems.length === 0,
                class: "btn btn-lg btn-primary"
              }, [
                _createElementVNode("span", _hoisted_53, [
                  _createElementVNode("span", _hoisted_54, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_55, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_56
                ])
              ], 8, _hoisted_52), [
                [_vShow, _ctx.props.id === 0]
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}